import React from "react";
import { Grid, Container, Row, Column } from "ui-grid";
import { domusoResponsiveStyleHelper } from "../../screens/new/utils/domuso-responsive";

export const BottomNav = (props: any) => {
  const { backgroundColor = "#FFF" } = props;

  return (
    <Grid>
      <Container
        style={{
          marginTop: -10,
          ...domusoResponsiveStyleHelper({
            iosTablet: {
              marginBottom: 20,
            },
            androidTablet: {
              marginBottom: 20,
            },
          }),
        }}>
        <Row>
          <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
          <Column
            span={{ xs: 12, sm: 8, md: 8, lg: 8 }}
            style={{
              backgroundColor: backgroundColor,
              alignSelf: "flex-end",
              bottom: 0,
              paddingTop: 15,
              paddingBottom: 15,
              marginRight: "auto",
              marginLeft: "auto",
              ...domusoResponsiveStyleHelper({
                webPhone: {},
                webTablet: {
                  paddingLeft: 40,
                  paddingRight: 40,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomWidth: 1,
                  borderBottomColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomRightRadius: 10,
                  borderBottomLeftRadius: 10,
                },
                webDesktop: {
                  paddingLeft: 40,
                  paddingRight: 40,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomWidth: 1,
                  borderBottomColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomRightRadius: 10,
                  borderBottomLeftRadius: 10,
                },
                iosPhone: {},
                iosTablet: {
                  paddingLeft: 40,
                  paddingRight: 40,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomWidth: 1,
                  borderBottomColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomRightRadius: 10,
                  borderBottomLeftRadius: 10,
                },
                androidPhone: {},
                androidTablet: {
                  paddingLeft: 40,
                  paddingRight: 40,

                  borderLeftWidth: 1,
                  borderLeftColor: "rgba(102, 102, 102, 0.1)",
                  borderRightWidth: 1,
                  borderRightColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomWidth: 1,
                  borderBottomColor: "rgba(102, 102, 102, 0.1)",
                  borderBottomRightRadius: 10,
                  borderBottomLeftRadius: 10,
                },
              }),
            }}>
            {props.children}
          </Column>
          <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
        </Row>
      </Container>
    </Grid>
  );
};
